let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1xw6j")).then(() => parcelRequire('l8fNN'));